import { useState } from "react";
// Ant Design
import { Typography } from "antd";
// Modal Components
import ContactUsModal from "./Footer/ContactUsModal";
import PrivacyPolicyModal from "./Footer/PrivacyPolicyModal";
import TermsOfServiceModal from "./Footer/TermsOfServiceModal";

const { Link, Text } = Typography;

// ==============================|| MAIN LAYOUT - FOOTER ||============================== //

const Footer = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);

  return (
    <>
      <div className="flex items-center justify-between px-4 py-1 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800">
        {/* Left side - Copyright */}
        <Text className="text-xs text-black dark:text-gray-400">
          © {new Date().getFullYear()} <span className="text-blue-600">Nexgensis</span>
        </Text>

        {/* Right side - Privacy Policy, Terms & Contact */}
        <div className="flex items-center gap-3">
          <Link
            onClick={() => setIsContactModalOpen(true)}
            className="text-xs text-black hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400 cursor-pointer"
          >
            Contact Us
          </Link>
          <span className="text-black dark:text-gray-600">|</span>
          <Link
            onClick={() => setIsPrivacyModalOpen(true)}
            className="text-xs text-black hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400 cursor-pointer"
          >
            Privacy Policy
          </Link>
          <span className="text-black dark:text-gray-600">|</span>
          <Link
            onClick={() => setIsTermsModalOpen(true)}
            className="text-xs text-black hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400 cursor-pointer"
          >
            Terms of Service
          </Link>
        </div>
      </div>

      {/* Modals */}
      <ContactUsModal
        open={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
      <PrivacyPolicyModal
        open={isPrivacyModalOpen}
        onClose={() => setIsPrivacyModalOpen(false)}
      />
      <TermsOfServiceModal
        open={isTermsModalOpen}
        onClose={() => setIsTermsModalOpen(false)}
      />
    </>
  );
};

export default Footer;
